import styled from 'styled-components'
import tokens from '@gympass/yoga-tokens'
import { ChevronUp } from '@gympass/yoga-icons'
import getBreakpoint from '@client/utils/breakpoints'

export const FrequentlyQuestionsWrapper = styled.section`
  padding-top: 20px;
  padding-bottom: 20px;
`

export const Panel = styled.section`
  display: flex;
  flex-direction: column;
  border-top: 1px solid #dbdbe8;
  cursor: pointer;
`

export const Icon = styled(ChevronUp)(
  ({ open }) => `
    margin-right: 16px;
    transition: transform .3s;
    transform: ${open ? 'rotate(0deg);' : 'rotate(180deg);'};
    fill: ${tokens.colors.vibin};

    @media (min-width: ${getBreakpoint('xl')}px) {
      width: 32px;
      margin-right: 0;
    }
  `
)

export const Header = styled.section(
  ({ open }) => `
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 72px;
  font-style: normal;
  font-weight: ${open ? 'bold' : '500'};
  font-size: 16px;

  @media (min-width: ${tokens.breakpoints.md.width}px) {
    font-size: 16px;
    line-height: 19px;
  }
`
)

export const Body = styled.section`
  display: flex;
  flex-direction: column;
  margin-bottom: 28px;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 25px;
  color: ${tokens.colors.deep};

  @media (min-width: ${tokens.breakpoints.md.width}px) {
    font-size: 16px;
    line-height: 25px;
  }
`
